import styles from "./AddGroupForm.module.scss";
import { useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import AddGroupMembers from "./AddGroupMembers";
import { User } from "../../../interfaces/interfaces";
import { MdOutlineRemoveCircleOutline } from "react-icons/md";
import { toast } from "react-toastify";
import { UsersRestS } from "../../../rest/users-rest-service";
import { Field, Form } from "react-final-form";
import { reqiredValidation } from "../../../components/functions/formValidation";
import arrayMutators from "final-form-arrays";
import setFieldTouched from "final-form-set-field-touched";
import notFoundImg from "../../../assets/images/NotFound.svg";

type props = {
  onClose: Function;
  toggle: Function;
};

export default function AddGroupForm({ onClose, toggle }: props) {
  const [isAddMembers, setIsAddMembers] = useState(false);
  const [members, setMembers] = useState<User[]>([]);
  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(false);

  const createBtn = () => {
    if (!groupName.trim()) {
      toast.error("Please add group name");
      return;
    }

    if (members.length < 2) {
      toast.error("Add atleast 2 users to create a group");
      return;
    }

    let userIds = members.map((e) => e.id);
    UsersRestS.CreateGroupWithMember(groupName, userIds)
      .then((res) => {
        onClose();
      })
      .catch((e) => console.log(e));
  };

  const removeUser = (user: User) => {
    let newList = members.filter((u) => u.id != user.id);
    setMembers([...newList]);
  };

  const onSubmit = async (values) => {
    // console.log(values);
    try {
      let userIds = values.members.map((e) => e.id);
      const data = await UsersRestS.CreateGroupWithMember(
        values.groupName,
        userIds
      );
      setLoading(false);
      onClose();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className={styles.addGroupForm}>
        <Form
          onSubmit={(values) => onSubmit(values)}
          mutators={{
            ...arrayMutators,
            setFieldTouched,
          }}
          // validateOnBlur={true}
          validate={(values) => {
            const errors = {};
            if (!values.members || values.members.length < 2) {
              errors["members"] = "* Add atleast 2 members in the group";
            }
            return errors;
          }}
          initialValues={{ groupName: "", members: [] }}
          keepDirtyOnReinitialize={true}
          render={({ handleSubmit, pristine, hasValidationErrors, values }) => (
            <form onSubmit={handleSubmit}>
              <div className={styles.groupInfoSection}>
                <div className={styles.groupTitle}>
                  <Field
                    name="groupName"
                    validate={(values) =>
                      reqiredValidation(values, "Group name")
                    }
                  >
                    {(props) => (
                      <>
                        <input
                          {...props.input}
                          className={`${styles.fullName} ${
                            props.meta.error && props.meta.touched
                              ? styles.invalid
                              : props.meta.submitError
                              ? styles.invalid
                              : ""
                          }`}
                          placeholder="Enter Group Name"
                          onChange={props.input.onChange}
                          value={props.input.value}
                          maxLength={25}
                        />
                        {props.meta.error && props.meta.touched ? (
                          <div className={styles.formError}>
                            {props.meta.error}
                          </div>
                        ) : props.meta.submitError ? (
                          <div className={styles.formError}>
                            {props.meta.submitError}
                          </div>
                        ) : null}
                      </>
                    )}
                  </Field>
                </div>
                <div className={styles.header}>
                  <button
                    type="reset"
                    className={`${styles.btn} ${styles.cancelBtn}`}
                    onClick={() => toggle()}
                  >
                    Cancel
                  </button>
                  <button
                    // type="reset"
                    type="submit"
                    disabled={pristine || hasValidationErrors}
                    className={`${styles.btn} ${styles.proceedBtn} ${
                      loading ? styles.loading : ""
                    } demo_create_group`}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    <div className={styles.buttonText}>Create</div>
                  </button>
                </div>
                <div className={styles.addMember}>Members</div>
              </div>
              <div className={styles.bottomContainer}>
                <Field name="members">
                  {(props) => (
                    <>
                      {props.input.value.length > 0 ? (
                        <>
                          <div className={styles.groupMembers}>
                            {props.input.value.map((member, index) => {
                              return (
                                <div className={styles.membersList} key={index}>
                                  <div className={styles.membersInfo}>
                                    <div
                                      style={{
                                        backgroundColor: member.color
                                          ? `#${member.color}`
                                          : "#596de7",
                                        cursor: "pointer",
                                      }}
                                      className={`${styles.profileImage}`}
                                    >
                                      {member.name.charAt(0).toUpperCase()}
                                    </div>
                                    <div
                                      className={styles.membersNameDesignation}
                                    >
                                      <div className={styles.membersName}>
                                        {member.name}
                                      </div>
                                      <div
                                        className={styles.membersDesignation}
                                      >
                                        {member.designation}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={styles.icon}
                                    onClick={() => {
                                      // removeUser(user)
                                      // fields.remove(index);
                                      props.input.onBlur();
                                      let newValues = [...props.input.value];
                                      newValues.splice(index, 1);
                                      props.input.onChange(newValues);
                                    }}
                                  >
                                    <MdOutlineRemoveCircleOutline />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {props.meta.error && props.meta.touched ? (
                            <div
                              className={`${styles.formError} ${styles.addPadding}`}
                            >
                              {props.meta.error}
                            </div>
                          ) : props.meta.submitError ? (
                            <div className={styles.formError}>
                              {props.meta.submitError}
                            </div>
                          ) : null}
                        </>
                      ) : (
                        <div className={styles.noMembers}>
                          {/* <BsPerson size="6rem" className={styles.icon} /> */}
                          <div className={styles.imgContainer}>
                            <img src={notFoundImg} />
                          </div>
                          <div style={{ marginTop: "0.5rem" }}>
                            No collaborates added
                          </div>
                          <div>Add atleast 2 users to create a group</div>
                        </div>
                      )}
                      <></>
                    </>
                  )}
                </Field>
                {/* <FieldArray name="members">
                                    {({ fields }) => {
                                        console.log(fields);
                                        // return <div></div>
                                        return <>
                                            {fields.length > 0 ?
                                                <div className={styles.groupMembers}>
                                                    {fields.map((path, index) => {
                                                        console.log("path", path)
                                                        return (
                                                            <Field name={`${path}`}>
                                                                {props => (
                                                                    <div className={styles.membersList} key={index}>
                                                                        <div className={styles.membersInfo}>
                                                                            <div className={`${styles.profileImage}`} style={{ cursor: 'pointer' }}>
                                                                                {props.input.value.name.charAt(0).toUpperCase()}
                                                                            </div>
                                                                            <div className={styles.membersNameDesignation}>
                                                                                <div className={styles.membersName}>{props.input.value.name}</div>
                                                                                <div className={styles.membersDesignation}>{props.input.value.designation}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className={styles.icon} onClick={() => {
                                                                            // removeUser(user)
                                                                            fields.remove(index);
                                                                        }}>
                                                                            <MdOutlineRemoveCircleOutline />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Field>

                                                        );
                                                    })}
                                                </div>
                                                : <div className={styles.noMembers}>
                                                    <BsPerson size="6rem" className={styles.icon} />
                                                    <div>
                                                        No collaborates added
                                                    </div>
                                                    <div>
                                                        Add atleast 2 users to create a group
                                                    </div>
                                                </div>}
                                            {fields.error && fields.touched ? <div className={styles.formError}>
                                                {fields.error}
                                            </div> : fields.submitError ? <div className={styles.formError}>
                                                {fields.submitError}

                                            </div> : null}
                                        </>

                                    }}
                                </FieldArray> */}
                {/* {members.length > 0 ?
                                <div className={styles.groupMembers}>
                                    {
                                        members.map((user: User, index) => {
                                            return (
                                                <div className={styles.membersList} key={index}>
                                                    <div className={styles.membersInfo}>
                                                        <div className={`${styles.profileImage}`} style={{ cursor: 'pointer' }}>
                                                            {user?.name.charAt(0).toUpperCase()}
                                                        </div>
                                                        <div className={styles.membersNameDesignation}>
                                                            <div className={styles.membersName}>{user.name}</div>
                                                            <div className={styles.membersDesignation}>{user.designation}</div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.icon} onClick={() => {
                                                        removeUser(user)
                                                    }}>
                                                        <MdOutlineRemoveCircleOutline />
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div> :
                                <div className={styles.noMembers}>
                                    <BsPerson size="6rem" className={styles.icon} />
                                    <div>
                                        No collaborates added
                                    </div>
                                    <div>
                                        Add atleast 2 users to create a group
                                    </div>
                                </div>
                            } */}

                <div className={styles.footer}>
                  <div className="d-flex justify-content-center">
                    <button
                      className={`${styles.addBtn} demo_add_members_btn`}
                      type="reset"
                      onClick={() => {
                        setIsAddMembers(true);
                      }}
                    >
                      <span>
                        <BsPlusCircle className="me-2" />
                        Add new user
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              {isAddMembers && (
                <AddGroupMembers
                  members={values.members}
                  onClose={() => {
                    setIsAddMembers(false);
                  }}
                  setMembers={setMembers}
                />
              )}
            </form>
          )}
        />
      </div>
    </>
  );
}
